import React from 'react';
import styled from 'styled-components';
import Header from '../../components/common/header/Header';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { reqEsItemInfoAction, reqEsOrderAction, reqEsOrderCodeReset, reqEsMultiOrderAction } from '../../modules/od/orderModule';
import { setCurMenuAction, setHeaderTransferAction } from '../../modules/common/headerModule';
import { useState } from 'react';
import Footer from '../../components/common/Footer';
import { split, slice, truncate } from 'lodash';
import NormalInput from '../../components/common/input/NormalInput';
import SelectDropDownBtn from '../../components/common/button/SelectDropDownBtn';
import BootPay from "bootpay-js";
import { OrderId, Log } from '../../lib/util/CustomUtil';
import TextArea from '../../components/common/textarea/TextArea';
import { useRef } from 'react';
import CheckBtn from '../../components/common/button/CheckBtn';
import { groupBy, forEach, remove, concat, findIndex, replace } from 'lodash';
import EsOrderList from '../../components/od/EsOrderList'
import {Toast, toast} from '../../components/common/noti/Toast'
import {Waypoint} from 'react-waypoint'; //for scroll spy
import LoadingOverlay from 'react-loading-overlay';
import $ from 'jquery';

import {EsComItemList, EsComSummary} from '../../components/es/index'

import { isMobileOnly } from 'react-device-detect';

const inputWidth=isMobileOnly?"92vw":"430px";

const EsOrderBlock = styled.div`
  ${isMobileOnly ? `
    margin: 0 4vw;
  `
  : `
    width: 100%;
    margin: 0 auto;`};
`;

const EsOrderContentsBlock = styled.div`
    ${isMobileOnly?`
    padding: 0px 0 0px;
         
    `:`
    padding: 60px 0 120px;
    `};

    
    ${isMobileOnly&&`
        .product-table{
          margin: 10px 0;
          border-top: 2px solid #111;  
        }
        .border {
            border-top: 2px solid #111;
            &.tpad { padding-top: 20px;}
        }
        
        .ps-btn {
            text-align: center;
            
            &::before, &.card::before,&.send::before,&.live::before {
                display: block;               
                width: 100%;
                margin:0;            
            }            
        }
        .payment_wing-box {
            transition: unset;
            float: none;
            width: unset;
            padding-left: 0;            
        }
    `}
`;

const EsOrderHeaderBlock = styled.div`
    ${isMobileOnly?`
        margin: 0;
         
    `:`
        width: 1176px;
        margin: 76px auto;
    `};
    height:${props => props.height2};
    padding-bottom: ${props => props.bottom};
    position:relative;
`;

const EsOrderHeaderTitleMBlock = styled.div`
    width: 100vw;
      
    height: 50px;
    //margin: 0 0 30px;
    //padding: 7px 125px 7px 2px;
    background-color: #ffffff;
    position: fixed;
    top: 0;
    z-index: 10;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    color: #111111;
    line-height: 50px;
    margin-left: -4vw;
`;

const EsOrderHeaderTitleMBtnBlock = styled.button`
    width: 36px;
    height: 36px;
    position: absolute;
    top: 7px;
    left: 2px;
    background: url(/assets/images/icon/back_btn.svg) center center/auto no-repeat;
`;

const EsOrderHeaderGrayLine = styled.div`
    height: 8px;
    width: 100vw;
    margin-left: -4vw;
    background-color: #ececec;
    border-top: 1px solid #e0e0e0;
`;

const EsOrderHeaderTitleBlock =styled.div`
    font-size: 32px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: left;
    color: #111111;
`;

const EsOrderSectionContentsBlock = styled.div`
    ${isMobileOnly?`
    margin: 0 4vw;
         
    `:`
    width: 1176px;
    margin: 0 auto;
    `};
    position: relative;
    
`;

const EsOrderMobileContentBlock = styled.div`

`;

const EsOrderSectionLeftBlock = styled.div`
    ${isMobileOnly?`
    
         
    `:`
    float: left;
    width : 775px;
    `};
    

    .header {
        ${isMobileOnly?`
        font-size: 16px;
        height: 24px;
        line-height: 24px;
        `:`
        font-size: 18px;
        height: 60px;
        line-height: 60px;
        `};

        font-weight: 500;
        text-align: left;
        color: #111111;
    }

    .line {
        height: 2px;
        background-color: #111111;
        margin-bottom: 30px;
    }

    .line2 {
        height: 1px;
        background-color: #cccccc;
    }

    .line-no-margin {
        height: 2px;
        background-color: #111111;
    }

    .content {
        ${isMobileOnly?`
        padding: 0 0px;
        `:`
        padding: 0 36px;
        `};
    }

    .gray-blcok {
        ${isMobileOnly?`
    
        `:`
        height: 51px;
        `};

        background-color:#f4f4f4;
        font-size: 13px;
        
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.31;
        letter-spacing: normal;
        text-align: center;
        color:#999999;
        padding: 17px 0;
    }
`;

const EsOrderSectionRightBlock = styled.div`
    ${isMobileOnly?`
    
         
    `:`
    float: left;
    //padding-left: 50px;
    width: 352px;
    `};
    
`;

const EsOrderRightContentsBlock = styled.div`

`;

const EsOrderRightHeaderBlcok = styled.div`
    height: 60px;
    font-size: 18px;
    font-weight: 500;
    line-height: 60px;
    text-align: left;
    color: #111111;
`;

const EsOrderMobilePayBlock = styled.div`
    margin-top: 30px;

    .checkblock {
        margin-right: 7px;
        float : left;
        margin-top: -4px;
    }

    .check_text {
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.69;
        letter-spacing: normal;
        text-align: left;
        color: #333333;
    }
`;

const EsOrderRightPayBlock = styled.div`
    ${isMobileOnly?`
    padding: 0px 10px;
         
    `:`
    width: 352px;
    padding: 30px 20px 30px 20.6px;
    border: solid 1px #111111;
    border-bottom-left-radius: 20px;
    `};

    .pay_wrap {
        height: 24px;
        margin-bottom: 20px;
    }

    .pay_wrap2 {
        ${isMobileOnly?`
        height: 18x;
        `:`
        fheight: 24px;
        `};

        margin-bottom: 6px;
    }

    .total_text {
        font-size: 14px;
        font-weight: 400;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: left;
        color: #333333;
    }

    .total_price {
        ${isMobileOnly?`
        font-size: 16px;
        line-height: 1.25;
        `:`
        font-size: 18px;
        line-height: 1.33;
        `};
        
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        
        letter-spacing: normal;
        text-align: right;
        color: #111111;
        float: right;
    }

    .delivery_text {
        ${isMobileOnly?`
        font-size: 14px;
        line-height: 20px;
        `:`
        font-size: 16px;
        line-height: 1.33;
        `};
        
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        
        letter-spacing: normal;
        text-align: right;
        color: #111111;
        float: right;
    }
    .sale {
        color: #79b88a;
    }

    .last {
        font-weight: 500;
    }

    .last_price {
        ${isMobileOnly?`
        font-size: 18px;
        line-height: 1.11;
        `:`
        font-size: 32px;
        line-height: 0.75;
        `};
        
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        
        letter-spacing: normal;
        text-align: right;
        color: #111111;
    }

    .checkblock {
        ${isMobileOnly?`
        margin-left: 4vw; 
        `:`
        margin-right: 7px;
        `};
        float : left;
        margin-top: -4px;
    }

    .check_text {
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.69;
        letter-spacing: normal;
        text-align: left;
        color: #333333;
    }

    .btn_pay {
        padding: 14.4px 120.7px 16.6px 116.3px;
        border-radius: 4px;
        background-color: #ffc742;
        width: 311px;
        height: 60px;

        font-size: 20px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: normal;
        text-align: left;
        color: #111111;
    }

    .pay-line {
        height: 1px;
        border-bottom: dashed 1px #cccccc;
    }

    .won {
        ${isMobileOnly?`
        font-size: 14px;
        `:`
        font-size: 16px;
        `};
        
        font-weight: normal;
    }

    .ex_delivery {
        ${isMobileOnly?`
        font-size: 12px;
        `:`
        font-size: 14px;
        `};

        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: right;
        color: #666666;

        .price {
            font-weight: 500;
            color: #333333;
            position: relative;
            display: inline-block;
            ::after {
                content: '';
                display: block;
                position: absolute;
                width: 100%;
                left: 0;
                bottom: 4px;
                height: 12px;
                background-color: #ffe7ad;
                z-index: -1;
            }
        }
    }
`;

const EsOrderUserBlock = styled.div`
    ${isMobileOnly?`
    margin-top: 30px;
         
    `:`
    margin-top: 80px;
    `};

    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    color: #333333;
`;

const EsOrderDeliveryBlock = styled.div`
    ${isMobileOnly?`
    margin-top: 30px;
    `:`
    margin-top: 80px;
    `};

    .title {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: left;
        color: #333333;
        //height: 40px;
        width : 80px;
        margin-right: 20px;
        padding-top: 14px;

        .pink {
            color:#fc1c67;
        }

        .top0 {
            padding-top: 0px;
        }
    }

    .input-right {
        ${isMobileOnly?`
        width: calc(92vw - 100px);
        `:`
        width: 600px;
        `};
        
        height: 40px
    }

    .input-select {
        ${isMobileOnly?`
        width: calc(92vw - 100px);
        `:`
        width: 600px;
        `};
    }

    .zip-right {
        ${isMobileOnly?`
        width: calc(92vw - 100px);
        `:`
        width: 600px;
        `};
    }

    .zip-code {
        ${isMobileOnly?`
        
        `:`
        height: 40px;
        `};

        font-size: 13px;
        line-height: 1.23;
        
        padding-top: 14px;
    }

    .address {
        font-size: 13px;
        line-height: 1.69;
    }

    .noti {
        ${isMobileOnly?`
        font-size: 12px;
        `:`
        font-size: 13px;
        `};
        
        line-height: 1.29;
        color: #999999;
    }

    .title-20 {
        height: 20px;
        padding: 3px 0;
    }

    .address-20 {
        height: 20px;
        padding: 0;
    }

    .right-same {
        ${isMobileOnly?`
        padding: 0 0px;
        `:`
        padding: 20px 0;
        `};
        font-size: 14px;
        font-weight: 500;
        color: #79b88a;
        float: right;
        
    }
`;

const EsOrderMethodBlock = styled.div`
    ${isMobileOnly?`
    margin-top: 30px;
    `:`
    margin-top: 80px;
    `};

    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    color: #333333;

    .payment_select-wrap2 .ps-btn {
        ${isMobileOnly?`
        width: 29vw;
        height: 40px;
        margin-left: 2vw;
        font-size: 13px;
        `:`
        width: 220px;
        height: 56px;
        margin-left: 20px;
        font-size: 14px;
        `};

    float: left;
    position: relative;
    color: #999;
    border: 1px solid #ccc;
    border-radius: 4px;
    /* border-left: none;
    border-top: none;
    text-align: left; */
    }
    .payment_select-wrap2 .ps-btn:first-child {
    margin-left: 0px;
    }

    .payment_select-wrap2 .ps-btn.active {
    color: #333;
    background-color: #ffe7ad;
    }

    .noti-text {
    text-align: center;
    margin: 20px;
    font-size: 12px;
    }

`;

const EsOrderRequestContainerBlock = styled.div`
    ${isMobileOnly?`
    height : 70px;
    width: 100vw;
    margin-left: -4vw;
    `:`
    height : 100px;
    width: 100%;
    margin: 0 auto;
    `};

    //display: ${props => props.display};
    position:relative;
    bottom:0;
    z-index: 10;
    background-color: #ffffff;
`;

const EsOrderRequestBlock = styled.div`
    ${isMobileOnly?`
    height : 70px;
    width: 100vw;
    left: 0;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    `:`
    height : 100px;
    width: 100vw;
    //min-width: 100%;
    right: 0;
    border-top-left-radius: 20px;
    //min-width : 771px;
    left: 0px;
    `};
    display: block;
    position:fixed;
    bottom:0;
    z-index: 10;
    background-color: #ffc742;
    z-index:9;
    
    &.nofixed {
        position:relative;
        //float: right;
        //button { font-weight: 600;}
        left: 0px;
  }
`;

const EsOrderRequestContentsBlock = styled.div`
    ${isMobileOnly?`
    height : 70px;
    width: 100vw;
    margin-left: -4vw;
    `:`
    height : 100px;
    //width: 1176px;
    width: 100vw;
    margin: 0 auto;
    //margin-top: 40px;
    `};

    //display: ${props => props.display};
    position:relative;
    bottom:0;
    z-index: 10;
`;


const EsOrderRequestBtnBlock = styled.button`
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: center;
    color: #111111;
    width: 100vw;
    height: 100%;
    margin-left: 4vw;

    .req-price {
    font-size: 18px;
    font-weight: bold;
    }
    
`;

const dvryOptions = [
    { value: 1, label: "배송요청사항을 선택해주세요" },
    { value: 2, label: "배송전 연락바랍니다." },
    { value: 3, label: "부재 시 문앞에 놔주세요." },
    { value: 4, label: "부재 시 경비실에 맡겨주세요." },
    { value: 5, label: "직접 입력 " }
];
const EsOrderMulti = ({ location }) => {

    const dispatch = useDispatch();
    const history = useHistory();

    const [revName, setRevName] = useState(""); // 수령인
    const [mobile1, setMobile1] = useState(""); // 전화번호 1

    const [phone1, setPhone1] = useState(""); // 전화번호 1

    const [reqDlrv, setReqDlrv] = useState("");
    const [isTextArea, setIsTextArea] = useState(false);

    const [agree, setAgree] = useState(false);
    const [escrow, setEscrow] = useState(false);
    const [same, setSame] = useState(true);

    const [method, setMethod] = useState("card");

    const recvNmRef = useRef(null);
    const mbRef1 = useRef(null);

    const [itemBrList, setItemBrList] = useState([]);
    const [prdductPrice, setProductPrice] = useState(0); //총 상품 금액
    const [dscPrice, setDscPrice] = useState(0);       // 총 할인 금액
    const [esDscPrice, setEsDscPrice] = useState(0);  //견적 할인 금액
    const [dvrPrice, setDvrPrice] = useState(0);        //배송비
    const [dvrAfterPrice, setDvrAfterPrice] = useState(0);        //착불배송비
    const [totalLastPrice, setTotalLastPrice] = useState(0);    //최종 결재 금액

    const [odName, setOdName] = useState(""); //주문자
    const [odEmail, setOdEmail] = useState("") //주문자 이메일
    const [odMobile, setOdMobile] = useState("") //주문자 이메일
    const refBlockReq = useRef(null);

    const { esItemInfo, esItemInfoRes, accessToken, curMenu, esOrderRes, loading } = useSelector(
        ({ userReducer, esOrderReducer, headerReducer, loadingReducer }) => ({
            accessToken: userReducer.accessToken,
            esItemInfoRes: esOrderReducer.esItemInfoRes,
            esItemInfo: esOrderReducer.esItemInfo,
            curMenu: headerReducer.curMenu,
            esOrderRes: esOrderReducer.esOrderRes,
            loading: loadingReducer['order/REQ_ORDER_MULTI'],
        })
    );

    useEffect(() => {

        if (curMenu !== 'od') {
            dispatch(setCurMenuAction('od'));
            dispatch(setHeaderTransferAction(false));
            window.scrollTo(0, 0);
        }

        if (accessToken === null || location.search === null
            || location.search === undefined) {
            history.push("/notfound");
        }
    });

    useEffect(() => {
        dispatch(reqEsItemInfoAction(location.search));
    }, [location])

    useEffect(() => {
        const onScroll = () => {
            if (isMobileOnly) {
                return;
            }
            var $bar = $('.payment_wing-box');
            if($bar.length){

                var nowScroll = $(window).scrollTop();
                    var offset = $('.payment-wrap').offset().top;
                    var offsetEnd = $('.payment-end').offset().top - 950; 
                    var move = nowScroll - offset;
/* 
                    console.log("nowScroll = " + nowScroll)
                    console.log("offset = " + offset)
                    console.log("offsetEnd = " + offsetEnd) */

                    if ( nowScroll > offsetEnd) {
                        move = offsetEnd;
                    } else {
                        move = nowScroll - offset;
                    }
                    //move = nowScroll - offset;

                    if ( nowScroll > offset ) {
                        $bar.css({'transform': 'translateY(' + move + 'px)', 'margin-top': '110px'});
                    } else {
                        $bar.css({'transform': 'none', 'margin-top': '0'});
                    }
            }
        };

        // scroll 이벤트를 만들어줍니다. 스크롤을 움직일때 마다
        // onScroll 함수가 실행됩니다.
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        if (esItemInfoRes === 600 || esItemInfoRes === 500) {
            dispatch(reqEsOrderCodeReset());
            history.push("/");
        } else if (esItemInfo !== null && esItemInfo !== undefined) {
            /* setRevName(esItemInfo.userinfo.rqst_nm);

            if (esItemInfo.userinfo.rqst_mo_no !== null) {
                setMyMobile1(getMobile(1));
                setMyMobile2(getMobile(2));
                setMyMobile3(getMobile(3));

                if (same) {
                    setMobile1(getMobile(1));
                    setMobile2(getMobile(2));
                    setMobile3(getMobile(3));
                }
            } */
        }
    }, [esItemInfoRes])

    useEffect(() => {

        // 주문 완료 후 완료 페이지로 이동
        if (esOrderRes !== null) {
            history.replace("/orderdone?odid=" + esOrderRes.data);
            dispatch(reqEsOrderCodeReset());
        }

    }, [esOrderRes])

    useEffect(() => {
        if(esItemInfo !== null && esItemInfo !== undefined && esItemInfo.items !== null && esItemInfo.items !== undefined && esItemInfo.items.length > 0) {
    
            let tmpList = [];
            if(esItemInfo.items !== null && esItemInfo.items.length > 0) {
                let resGrpJson = groupBy(esItemInfo.items, (item) => {
                    return item.es_rqst_id;
                });
    
                forEach(resGrpJson, (value, key) => {
                    let tmpItem = { 'es_rqst_id': key, 'list': value };

                    tmpList.push(tmpItem);
                })

                //console.log("tmpList = " + JSON.stringify(tmpList))
                setItemBrList(tmpList);
            }

            let _prdductPrice = 0;//총 상품 금액
            let _dscPrice = 0;// 총 할인 금액
            let _esDscPrice = 0;//견적 할인 금액
            let _dvrPrice = 0;//배송비
            let _dvrAfterPrice = 0;//착불배송비
            let _totalLastPrice = 0;//최종 결재 금액

            forEach(tmpList, (item, index) => {

                _prdductPrice = _prdductPrice + item.list[0].es_prdct_total_price;
                _dscPrice = _dscPrice + item.list[0].es_dscnt_total_price;
                _esDscPrice = _esDscPrice + item.list[0].es_dscnt_total_price;
                _totalLastPrice = _totalLastPrice + item.list[0].es_final_price;

                if (item.list[0].es_dlvry_final_pay_type === '025201') { //선불
                    _dvrPrice = _dvrPrice + item.list[0].es_dlvry_total_price;
                } else if (item.list[0].es_dlvry_final_pay_type === '025202') { // 착불
                    _dvrAfterPrice = _dvrAfterPrice + item.list[0].es_dlvry_total_price;
                } else {
                    
                }

            });

            _totalLastPrice = _totalLastPrice + _dvrPrice;
            setProductPrice(_prdductPrice);
            setDscPrice(_dscPrice);
            setEsDscPrice(_esDscPrice);
            setDvrPrice(_dvrPrice);
            setDvrAfterPrice(_dvrAfterPrice);
            setTotalLastPrice(_totalLastPrice);
            

            setOdName(esItemInfo.userinfo[0].rqst_nm);
            setOdEmail(esItemInfo.userinfo[0].rqst_id);
            
        }

    }, [esItemInfo])

    /* useEffect(() => {
        const onScroll = () => {
          if(!isMobileOnly) {
              $('.fixed').css({left: 0 - $(window).scrollLeft()});
              $('.nofixed').css({left: 0 });
          }
        };
      
        if(!isMobileOnly) {
            $('.fixed').css({left: 0 - $(window).scrollLeft()});
            $('.nofixed').css({left: 0 });
        }
        
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
      }, []); */

    if (accessToken === null || esItemInfoRes === 600 || esItemInfoRes === 500) {
        dispatch(reqEsOrderCodeReset());
        history.push("/");
        // return <Redirect to="/" />
    }

    if (esItemInfoRes === null || esItemInfo === null) {
        return <EsOrderBlock />
    }

    const hanldeRevNameInput = (e) => {
        setRevName(e.target.value);
    }

    const handleMobile1 = (e) => {
        setMobile1(e.target.value);
    }

    const handlePhone1 = (e) => {
        setPhone1(e.target.value);
    }

    const handlerChangeDvryOption = (param) => {

        if (param.value === 5) {
            setReqDlrv("");
            setIsTextArea(true);
        } else {
            if (param.value === 1) {
                setReqDlrv("");
            } else {
                setReqDlrv(param.label);
            }

            setIsTextArea(false);
        }

    }

    const handleDvryText = (e) => {
        setReqDlrv(e.target.value);
    }

    const handleAgreeClick = (param) => {
        setAgree(param);
    }

    const handleEscrowClick = (param) => {
        setEscrow(param);
    }

    const getPayPrice = () => {
        return totalLastPrice;
    }

    const checkValid = () => {

        if (revName === "") {
            let msg = "수령인을 입력해주세요";
            toast('SUCCESS', msg);

            if(recvNmRef.current) {
                recvNmRef.current.focus();
            }
            return false;
        }

        if (mobile1 === "" ) {
            let msg = "연락처를 입력해주세요";
            toast('SUCCESS', msg);

            if(mbRef1.current) {
                mbRef1.current.focus();
            }
            return false;
        }

        if (agree === false) {
            let msg = "마지막 필수 사항을 선택해주세요";
            toast('SUCCESS', msg);

            window.scrollTo(0,document.body.scrollHeight - 1200);
            return false;
        }

        return true;
    }

    const handleMethodClick = (param) => {
        setMethod(param);
    }

    const handleSameOrderInfo = (param) => {
        //console.log("recvNmRef  :  " + recvNmRef.current.value);
        //setSame(param);
        recvNmRef.current.value = esItemInfo.userinfo[0].rqst_nm;
        mbRef1.current.value = esItemInfo.userinfo[0].rqst_mo_no;
        setMobile1(esItemInfo.userinfo[0].rqst_mo_no);
        setRevName(esItemInfo.userinfo[0].rqst_nm);

        /* if (param === false) {
            recvNmRef.current.value = "";
            mbRef1.current.value = "";
            mbRef2.current.value = "";
            mbRef3.current.value = "";
            setMobile1("");
            setRevName("");
        } else {
            recvNmRef.current.value = esItemInfo.userinfo[0].rqst_nm;
            mbRef1.current.value = esItemInfo.userinfo[0].rqst_mo_no;
            setMobile1(esItemInfo.userinfo[0].rqst_mo_no);
            setRevName(esItemInfo.userinfo.rqst_nm);
        } */
    }

    const getMobileText = () => {
        let mobile = getMobile(1)+"."+getMobile(2)+"."+getMobile(3);
        //setOdMobile(mobile);

        return mobile;

    }
    const getRecvName = () => {

        if (same) {
            return esItemInfo.userinfo.rqst_nm;
        } else {
            return "";
        }
    }

    const getMobile = (param) => {

        if (esItemInfo.userinfo[0].rqst_mo_no === null) {
            return "";
        }

        let length = esItemInfo.userinfo[0].rqst_mo_no.length;
        let scndEnd = length - 4;

        if (param === 1) {
            return esItemInfo.userinfo[0].rqst_mo_no.substring(0, 3);
        } else if (param === 2) {
            return esItemInfo.userinfo[0].rqst_mo_no.substring(3, scndEnd);
        } else if (param === 3) {
            return esItemInfo.userinfo[0].rqst_mo_no.substring(scndEnd, length);
        } else {
            return "";
        }
    }

    const getPckgeName = () => {
        if(esItemInfo.userinfo.length > 1) {
            return esItemInfo.userinfo[0].pckg_nm + " 외 " + (esItemInfo.userinfo.length-1) + "건";
        }

        return esItemInfo.userinfo[0].pckg_nm;
    }

    const getBrandName = () => {
        let brnd_nm = "";
        forEach(itemBrList, (item, index) => {
            let index1 = brnd_nm.indexOf(item.list[0].brnd_han)

            if(index1 < 0) {
                if(brnd_nm.length == 0) {
                    brnd_nm = item.list[0].brnd_han;
                } else {
                    brnd_nm = brnd_nm + "," + item.list[0].brnd_han;
                }
            }
        });

        return brnd_nm;
    }

    const getBrandExpName = () => {
        let brnd_nm = itemBrList[0].list[0].brnd_han;

        if(esItemInfo.userinfo.length > 1) {
            return brnd_nm + " 외 " + (esItemInfo.userinfo.length-1) + "건";
        }

        return brnd_nm;
    }

    const testSubmit = () => {
        //let revName = revName;
        let mobile = mobile1;
        let phone = phone1;
        //let reqDlrv = reqDlrv;
        let payinfo = {};
        let params = {};
        params.method = 'card';
        params.rqst_nm= esItemInfo.userinfo[0].rqst_nm;
        params.rqst_id= esItemInfo.userinfo[0].rqst_id;
        params.pckg_nm= getPckgeName();
        params.brnd_han= getBrandName();
        params.brnd_han_exp = getBrandExpName();

        payinfo.receipt_id = '5f8684238f0751003b87e5c0';
        payinfo.method = 'card'
        payinfo.method_name = "ISP / 앱카드결제"
        payinfo.price = totalLastPrice;
        payinfo.purchased_at = "2021-01-08 18:08:10"
        payinfo.order_id = OrderId();
        payinfo.params = params;

        let es_id = "";

        forEach(esItemInfo.userinfo, (curobj, index) => {
            es_id = es_id + curobj.es_id + ",";
        });

        console.log("es_id = " + es_id)
        console.log("payinfo = " + JSON.stringify(payinfo));
        console.log("revName = " + revName)
        dispatch(reqEsMultiOrderAction(
        es_id,
        revName,
        mobile,
        phone,
        reqDlrv,
        esItemInfo.userinfo.length,
        payinfo))  

        /* {"_ES_ID":202009021246163073,"_REVNAME" :김효영2,"_MOBILE1" :01025726504,"_MOBILE2" :010,"_REQDLRV" :,
        "_BOOTPAY_ID" :5f744ada18e1ae002b53517d,"_METHOD" :card,"_METHOD_NAME" :ISP / 앱카드결제,
        "_PAY_PRICE" :157800,"_APPLY_DATE" :2020-09-30 18:08:10,"_ORDER_ID" :202009301807384795}

        userid, reqinfo.es_id, reqinfo.revname, reqinfo.mobile1,
                reqinfo.mobile2, reqinfo.reqdlrv, reqinfo.payinfo.receipt_id,
                reqinfo.payinfo.method, reqinfo.payinfo.method_name,
                reqinfo.payinfo.price, reqinfo.payinfo.purchased_at,
                reqinfo.payinfo.order_id */
    }
    const handleSubmit = () => {

        // Log("reqDlrv : " +  reqDlrv)
        if (!checkValid()) {
            return;
        }

        //testSubmit()
     //return;
        
    let pckg_nm= getPckgeName();
    let brnd_han= getBrandName();
    let brnd_han_exp = getBrandExpName();
    let es_id = "";
    let count = esItemInfo.userinfo.length;

    forEach(esItemInfo.userinfo, (curobj, index) => {
        es_id = es_id + curobj.es_id + ",";
    });

        const odid = OrderId();
        BootPay.request({
            price: getPayPrice(), //실제 결제되는 가격
            application_id: process.env.REACT_APP_BOOTPAY_ID,
            name: "[" + process.env.REACT_APP_BOOTPAY_NAME + "] " + pckg_nm, //결제창에서 보여질 이름
            pg: 'inicis',
            method: method, //결제수단, 입력하지 않으면 결제수단 선택부터 화면이 시작합니다.
            show_agree_window: 0, // 부트페이 정보 동의 창 보이기 여부
            user_info: {
                username: esItemInfo.userinfo[0].rqst_nm,
                email: esItemInfo.userinfo[0].rqst_id,
                addr: esItemInfo.userinfo[0].addr1 + esItemInfo.userinfo[0].addr2,
                phone: esItemInfo.userinfo[0].rqst_mo_no
            },
            order_id: odid, //고유 주문번호로, 생성하신 값을 보내주셔야 합니다.
            params: {
                es_id: es_id,
                es_rqst_id: esItemInfo.items[0].es_rqst_id,
                method: method,
                price: getPayPrice(),
                rqst_nm: esItemInfo.userinfo[0].rqst_nm,
                rqst_id: esItemInfo.userinfo[0].rqst_id,
                pckg_nm: esItemInfo.userinfo[0].pckg_nm,
                brnd_han_exp: brnd_han_exp,
                brnd_han: brnd_han
            },
            extra: {
                escrow: escrow
            }
        }).error(function (data) {
            //결제 진행시 에러가 발생하면 수행됩니다.
            // console.log(data);
        }).cancel(function (data) {
            //결제가 취소되면 수행됩니다.
            // console.log(data);
        }).ready(function (data) {
            // 가상계좌 입금 계좌번호가 발급되면 호출되는 함수입니다.
            // console.log(data);
            // 주문서 등록 api 호출
            dispatch(
                reqEsMultiOrderAction(
                    es_id,
                    revName,
                    mobile1,
                    phone1,
                    reqDlrv,
                    count,
                    data)
            );

        }).confirm(function (data) {
            //결제가 실행되기 전에 수행되며, 주로 재고를 확인하는 로직이 들어갑니다.
            //주의 - 카드 수기결제일 경우 이 부분이 실행되지 않습니다.
            // console.log(data);
            var enable = true; // 재고 수량 관리 로직 혹은 다른 처리
            if (enable) {
                BootPay.transactionConfirm(data); // 조건이 맞으면 승인 처리를 한다.
            } else {
                BootPay.removePaymentWindow(); // 조건이 맞지 않으면 결제 창을 닫고 결제를 승인하지 않는다.
            }
        }).close(function (data) {
            // 결제창이 닫힐때 수행됩니다. (성공,실패,취소에 상관없이 모두 수행됨)
            // console.log(data);
        }).done(function (data) {
            //결제가 정상적으로 완료되면 수행됩니다
            //비즈니스 로직을 수행하기 전에 결제 유효성 검증을 하시길 추천합니다.
            // console.log(data);

            // 주문서 등록 api 호출
            dispatch(
                reqEsMultiOrderAction(
                    es_id,
                    revName,
                    mobile1,
                    phone1,
                    reqDlrv,
                    count,
                    data)
            );

        });
    }

    const handleBack = () => {
        history.goBack();
    }

    const checkBottomPosition = (props) => {
        //console.log('check = ',JSON.stringify(props))

       if(props.currentPosition === Waypoint.below && refBlockReq.current) {
           //console.log("nofixed remove")
           //refBlockReq.current.classList.remove('nofixed');
           //refBlockReq.current.classList.add('fixed');
       } 
       else if(props.currentPosition === Waypoint.inside && props.previousPosition === Waypoint.below && refBlockReq.current) {
           //console.log("nofixed add")
           //refBlockReq.current.classList.remove('fixed');
           //refBlockReq.current.classList.add('nofixed');
       }
       //console.log('check = ',JSON.stringify(refBlockReq.current.classList))

   }

   const getDevtext = () => {

    //console.log("dvrAfterPrice = " + dvrAfterPrice)
    //console.log("dvrPrice = " + dvrPrice)
        if(dvrAfterPrice > 0 && dvrPrice === 0) {
            return <span className="delivery_text">별도 결제</span>
        } else if(dvrAfterPrice === 0 && dvrPrice === 0) {
            return <span className="delivery_text">무료</span>
        }
        return <span className="total_price">{Number(dvrPrice.toFixed(1)).toLocaleString()}<span className="won">원</span></span>;
   }

    return (
        <EsOrderBlock>
            
            {!isMobileOnly&&<Header />}
            {
                isMobileOnly?
                <EsOrderContentsBlock>
                    <EsOrderHeaderBlock>
                        <EsOrderHeaderTitleMBlock><EsOrderHeaderTitleMBtnBlock onClick={handleBack}/>견적서 주문</EsOrderHeaderTitleMBlock>
                        <EsOrderHeaderGrayLine className="margin_b-10 margin_t-50"/>
                    </EsOrderHeaderBlock>
                    <EsOrderMobileContentBlock className="clearfix" >
                        <EsOrderSectionLeftBlock>
                            <EsOrderList itemBrList={itemBrList} />
                            <EsOrderHeaderGrayLine className="margin_t-10"/>
                            <EsOrderUserBlock>
                                <div className="header margin_b-20">주문자 정보</div>
                                {/* <div className="line"></div> */}
                                <div className="content margin_b-30">
                                    <div className="margin_b-10"><span>{odName} {getMobileText()}</span></div>
                                    <div className="margin_b-20"><span>{odEmail}</span></div>
                                    <div className="gray-blcok">*주문하신 내역은 메일과 연락처로 발송됩니다.</div>
                                </div>
                                
                            </EsOrderUserBlock>
                            <EsOrderHeaderGrayLine className="margin_t-10"/>
                            <EsOrderDeliveryBlock>
                            <div className="header margin_b-30">배송지 정보 <button className="right-same" onClick={handleSameOrderInfo}>주문자 정보 동일</button></div>
                                {/* <div className="line"></div> */}
                                <div className="content margin_b-30">
                                    <div className="margin_b-30 clearfix">
                                        <p className="title f-left">수령인<span className="pink">*</span></p>
                                        <div className="f-left input-right" style={{ display: 'inline-block' }} >
                                            <NormalInput
                                            inputRef={recvNmRef}
                                            type="text"
                                            //width={inputWidth}
                                            defaultValue={getRecvName()}
                                            marginBottom='10px'
                                            onChange={hanldeRevNameInput}
                                            placeholder="이름을 입력해 주세요."
                                            />

                                        </div>
                                    </div>
                                    <div className="margin_b-30 clearfix">
                                        <p className="title title-20 f-left">우편번호<span className="pink">*</span></p>
                                        <div className="f-left address-20 input-right" style={{ display: 'inline-block' }} >
                                            <span className="zip-code title-20">{esItemInfo.userinfo[0].zipcode}</span>
                                        </div>
                                    </div>
                                    <div className="clearfix margin_b-30 ">
                                        <p className="title title-20 f-left">주소<span className="pink">*</span></p>
                                        <div className="f-left zip-right clearfix" style={{ display: 'inline-block' }} >
                                            <span className="zip-code title-20">{esItemInfo.userinfo[0].addr1},{esItemInfo.userinfo[0].addr2}</span>
                                        
                                        <p className="margin_t-10"><span className="noti title-20">*배송 주소로 견적이 진행되어 변경 불가합니다.</span></p>
                                        </div>
                                    </div>
                                    <div className="clearfix margin_b-30 ">
                                        <p className="title f-left">연락처1<span className="pink">*</span></p>
                                        <div className="f-left input-right" style={{ display: 'inline-block' }} >
                                            <NormalInput
                                            inputRef={mbRef1}
                                            type="text"
                                            width="100%"
                                            defaultValue={mobile1}
                                            marginBottom='10px'
                                            maxLength="20"
                                            placeholder="연락처를 입력해주세요"
                                            onChange={handleMobile1}
                                            />

                                        </div>
                                    </div>
                                    <div className="clearfix margin_b-30">
                                        <p className="title f-left">연락처2</p>
                                        <div className="f-left input-right" style={{ display: 'inline-block' }} >
                                            <NormalInput
                                            type="text"
                                            width="100%"
                                            maxLength="20"
                                            marginBottom='10px'
                                            placeholder="연락처를 입력해주세요"
                                            defaultValue={phone1}
                                            value={phone1}
                                            onChange={handlePhone1}
                                            />

                                        </div>
                                    </div>
                                    <div className="clearfix margin_b-20">
                                        <p className="title f-left">배송요청사항</p>
                                        <div className="f-left input-select " style={{ display: 'inline-block' }} >
                                            <div className="product-select" style={{ width: '100%', marginBottom: '10px' }}>
                                                <SelectDropDownBtn
                                                options={dvryOptions}
                                                placeholder="배송요청사항을 선택해주세요"
                                                onChange={handlerChangeDvryOption} />
                                            </div>


                                            <TextArea
                                            placeholder="배송 요청사항을 기입해주세요"
                                            height="160px" onChange={handleDvryText}
                                            visible={isTextArea}
                                            value={reqDlrv}
                                            />

                                        </div>
                                    </div>
                                    <div className="gray-blcok">*도서산간 지역의 경우 추후 수령 시<p>추가배송비가 과금 될 수 있습니다.</p> </div>
                                </div>
                                
                            </EsOrderDeliveryBlock>
                            <EsOrderHeaderGrayLine className="margin_t-10"/>
                            <EsOrderMethodBlock>
                                <div className="header margin_b-30">결제 정보</div>
                                    {/* <div className="line"></div> */}
                                    <div className="content margin_b-30">
                                        <div className="payment_select-wrap2 clearfix" >
                                            <button type="button" className={method === 'card' ? "ps-btn card active" : "ps-btn card"}
                                                    onClick={() => { handleMethodClick("card") }}>
                                                신용 / 체크카드
                                            </button>
                                            <button type="button" className={method === 'vbank' ? "ps-btn send active" : "ps-btn send"}
                                                    onClick={() => { handleMethodClick("vbank") }}>
                                                무통장입금
                                            </button>
                                            <button type="button" className={method === 'bank' ? "ps-btn live active" : "ps-btn live"}
                                                    onClick={() => { handleMethodClick("bank") }}>
                                                실시간 계좌 이체
                                            </button>
                                            {/* <button type="button" className={ method === 'kakao' ? "ps-btn kakao active" : "ps-btn kakao"}
                                                        onClick={()=>{handleMethodClick("kakao")}}>
                                                        카카오페이
                                                    </button> */}
                                            {/* <button type="button" class="ps-btn naver">네이버페이</button> */}
                                        </div>
                                        <div className="payment_select-text2">
                                                <div className="ps-text pink" style={{ display: method === 'vbank' ? 'block' : 'none' }}>
                                                    <div>
                                                        <p className="noti-text">
                                                        *주문일 기준 +3일 이내, 미입금 시 자동 주문 취소됩니다.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                    </div>
                                
                            </EsOrderMethodBlock>
                            <EsOrderHeaderGrayLine className="margin_t-10"/>
                            <EsOrderMobilePayBlock>
                                <div className="header margin_b-30">최종 결제 정보</div>
                                <EsOrderRightPayBlock>
                                    <div className="margin_b-16" ><span className="total_text">총 상품 금액</span><span className="total_price">{Number(prdductPrice.toFixed(1)).toLocaleString()}<span className="won">원</span></span></div>
                                    <div className="margin_b-16 pay-line"></div>
                                    <div className="pay_wrap2" ><span className="total_text">총 할인 금액</span><span className="total_price">-{Number(dscPrice.toFixed(1)).toLocaleString()}<span className="won">원</span></span></div>
                                    <div className="margin_b-16" ><span className="total_text sale">∙견적 할인</span><span className="total_price sale">-{Number(esDscPrice.toFixed(1)).toLocaleString()}<span className="won">원</span></span></div>
                                    <div className="margin_b-16 pay-line"></div>
                                    <div className="margin_b-16" ><span className="total_text">배송비</span>{getDevtext()}</div>
                                    <div className="line-no-margin margin_b-16 "></div>
                                    <div className="margin_b-10"><span className="total_text last">최종 결제 금액</span><span className="total_price last_price">{Number(totalLastPrice.toFixed(1)).toLocaleString()}<span className="won">원</span></span></div>
                                    {dvrAfterPrice>0&&<div ><p className="ex_delivery">예상 착불 배송비는 <div className="price"><span>{Number(dvrAfterPrice.toFixed(1)).toLocaleString()}<span className="won">원</span></span></div>입니다.</p></div>}
                                    {dvrAfterPrice>0&&<div className="margin_b-30" ><p className="ex_delivery">미리 준비해주세요.</p></div>}
                                    {dvrAfterPrice===0&&<div className="margin_b-30" ><p className="ex_delivery"></p></div>}
                                </EsOrderRightPayBlock>
                                <EsOrderHeaderGrayLine className="margin_t-10 margin_b-30"/>
                                <div className="margin_b-20"><div className="checkblock">
                                        <CheckBtn onClick={handleAgreeClick} defaultValue={agree}/> </div> <span className="check_text">(필수) 주문하실 상품 및 결제, 주문 정보를 확인하였으며, 이에 동의합니다.</span></div>
                                    {/* <button className="btn_pay" onClick={handleSubmit}>결제하기</button> */}
                            </EsOrderMobilePayBlock>

                        </EsOrderSectionLeftBlock>
                    </EsOrderMobileContentBlock>
                    <div className="payment-end"></div>
                    <EsOrderRequestContainerBlock >
                    
                        <EsOrderRequestBlock ref={refBlockReq} >
                        <LoadingOverlay
                                    active={loading}
                                    spinner
                                    text=''
                                    >
                            <EsOrderRequestContentsBlock>
                                <EsOrderRequestBtnBlock onClick={handleSubmit}>
                                    <span className="req-price">{Number(totalLastPrice.toFixed(1)).toLocaleString()}</span><span>원 결제하기</span>
                                </EsOrderRequestBtnBlock>
                            </EsOrderRequestContentsBlock>
                            </LoadingOverlay>
                        </EsOrderRequestBlock>
                    
                    </EsOrderRequestContainerBlock>
                    <Waypoint onPositionChange={(props)=>checkBottomPosition(props)} fireOnRapidScroll></Waypoint>
                </EsOrderContentsBlock>
                :
                <EsOrderContentsBlock>
                    <EsOrderHeaderBlock>
                        <EsOrderHeaderTitleBlock>견적서 주문</EsOrderHeaderTitleBlock> 
                    </EsOrderHeaderBlock>
                    <EsOrderSectionContentsBlock className="payment-wrap clearfix" >
                        <EsOrderSectionLeftBlock>
                            <EsOrderList itemBrList={itemBrList} />
                            <EsOrderUserBlock>
                                <div className="header">주문자 정보</div>
                                <div className="line"></div>
                                <div className="content margin_b-30">
                                    <div className="margin_b-10"><span>{odName} {getMobileText()}</span></div>
                                    <div className="margin_b-20"><span>{odEmail}</span></div>
                                    <div className="gray-blcok">*주문하신 내역은 메일과 연락처로 발송됩니다.</div>
                                </div>
                                <div className="line2"></div>
                            </EsOrderUserBlock>
                            <EsOrderDeliveryBlock>
                            <div className="header">배송지 정보 <button className="right-same" onClick={handleSameOrderInfo}>주문자 정보 동일</button></div>
                                <div className="line"></div>
                                <div className="content margin_b-30">
                                    <div className="margin_b-30 clearfix">
                                        <p className="title f-left">수령인<span className="pink">*</span></p>
                                        <div className="f-left input-right" style={{ display: 'inline-block' }} >
                                            <NormalInput
                                            inputRef={recvNmRef}
                                            type="text"
                                            //width={inputWidth}
                                            defaultValue={getRecvName()}
                                            marginBottom='10px'
                                            onChange={hanldeRevNameInput}
                                            placeholder="이름을 입력해 주세요."
                                            />

                                        </div>
                                    </div>
                                    <div className="margin_b-30 clearfix">
                                        <p className="title title-20 f-left">우편번호<span className="pink">*</span></p>
                                        <div className="f-left address-20 input-right" style={{ display: 'inline-block' }} >
                                            <span className="zip-code title-20">{esItemInfo.userinfo[0].zipcode}</span>
                                        </div>
                                    </div>
                                    <div className="clearfix margin_b-30 ">
                                        <p className="title title-20 f-left">주소<span className="pink">*</span></p>
                                        <div className="f-left clearfix" style={{ display: 'inline-block' }} >
                                            <span className="zip-code title-20">{esItemInfo.userinfo[0].addr1},{esItemInfo.userinfo[0].addr2}</span>
                                        
                                        <p className="margin_t-10"><span className="noti title-20">*배송 주소로 견적이 진행되어 변경 불가합니다.</span></p>
                                        </div>
                                    </div>
                                    <div className="clearfix margin_b-30 ">
                                        <p className="title f-left">연락처1<span className="pink">*</span></p>
                                        <div className="f-left input-right" style={{ display: 'inline-block' }} >
                                            <NormalInput
                                            inputRef={mbRef1}
                                            type="text"
                                            width="100%"
                                            defaultValue={mobile1}
                                            marginBottom='10px'
                                            maxLength="20"
                                            placeholder="연락처를 입력해주세요"
                                            onChange={handleMobile1}
                                            />

                                        </div>
                                    </div>
                                    <div className="clearfix margin_b-30">
                                        <p className="title f-left">연락처2</p>
                                        <div className="f-left input-right" style={{ display: 'inline-block' }} >
                                            <NormalInput
                                            type="text"
                                            width="100%"
                                            maxLength="20"
                                            marginBottom='10px'
                                            placeholder="연락처를 입력해주세요"
                                            defaultValue={phone1}
                                            value={phone1}
                                            onChange={handlePhone1}
                                            />

                                        </div>
                                    </div>
                                    <div className="clearfix margin_b-20">
                                        <p className="title f-left">배송요청사항</p>
                                        <div className="f-left input-select " style={{ display: 'inline-block' }} >
                                            <div className="product-select" style={{ width: '100%', marginBottom: '10px' }}>
                                                <SelectDropDownBtn
                                                options={dvryOptions}
                                                placeholder="배송요청사항을 선택해주세요"
                                                onChange={handlerChangeDvryOption} />
                                            </div>


                                            <TextArea
                                            placeholder="배송 요청사항을 기입해주세요"
                                            height="160px" onChange={handleDvryText}
                                            visible={isTextArea}
                                            value={reqDlrv}
                                            />

                                        </div>
                                    </div>
                                    <div className="gray-blcok">*도서산간 지역의 경우 추후 수령 시 추가배송비가 과금 될 수 있습니다.</div>
                                </div>
                                <div className="line2"></div>
                            </EsOrderDeliveryBlock>

                            <EsOrderMethodBlock>
                                <div className="header">결제 정보</div>
                                    <div className="line"></div>
                                    <div className="content margin_b-30">
                                        <div className="payment_select-wrap2 clearfix" >
                                            <button type="button" className={method === 'card' ? "ps-btn card active" : "ps-btn card"}
                                                    onClick={() => { handleMethodClick("card") }}>
                                                신용 / 체크카드
                                            </button>
                                            <button type="button" className={method === 'vbank' ? "ps-btn send active" : "ps-btn send"}
                                                    onClick={() => { handleMethodClick("vbank") }}>
                                                무통장입금
                                            </button>
                                            <button type="button" className={method === 'bank' ? "ps-btn live active" : "ps-btn live"}
                                                    onClick={() => { handleMethodClick("bank") }}>
                                                실시간 계좌 이체
                                            </button>
                                            {/* <button type="button" className={ method === 'kakao' ? "ps-btn kakao active" : "ps-btn kakao"}
                                                        onClick={()=>{handleMethodClick("kakao")}}>
                                                        카카오페이
                                                    </button> */}
                                            {/* <button type="button" class="ps-btn naver">네이버페이</button> */}
                                        </div>
                                        <div className="payment_select-text2">
                                                <div className="ps-text pink" style={{ display: method === 'vbank' ? 'block' : 'none' }}>
                                                    <div>
                                                        <p className="noti-text">
                                                        *주문일 기준 +3일 이내, 미입금 시 자동 주문 취소됩니다.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                    </div>
                                <div className="line2"></div>
                            </EsOrderMethodBlock>

                        </EsOrderSectionLeftBlock>
                        <EsOrderSectionRightBlock>
                            <EsOrderRightContentsBlock className="payment_wing-box">
                                <EsOrderRightHeaderBlcok>결제 금액</EsOrderRightHeaderBlcok>
                                
                                <EsOrderRightPayBlock>
                                    <div className="margin_b-20" ><span className="total_text">총 상품 금액</span><span className="total_price">{Number(prdductPrice.toFixed(1)).toLocaleString()}<span className="won">원</span></span></div>
                                    <div className="pay_wrap2" ><span className="total_text">총 할인 금액</span><span className="total_price">-{Number(dscPrice.toFixed(1)).toLocaleString()}<span className="won">원</span></span></div>
                                    <div className="margin_b-20" ><span className="total_text sale">∙견적 할인</span><span className="total_price sale">-{Number(esDscPrice.toFixed(1)).toLocaleString()}<span className="won">원</span></span></div>
                                    <div className="margin_b-30" ><span className="total_text">배송비</span>{getDevtext()}</div>
                                    <div className="margin_b-30 pay-line"></div>
                                    <div className="margin_b-30"><span className="total_text last">최종 결제 금액</span><span className="total_price last_price">{Number(totalLastPrice.toFixed(1)).toLocaleString()}<span className="won">원</span></span></div>
                                    {dvrAfterPrice>0&&<div ><p className="ex_delivery">예상 착불 배송비는 <div className="price"><span>{Number(dvrAfterPrice.toFixed(1)).toLocaleString()}<span className="won">원</span></span></div>입니다.</p></div>}
                                    {dvrAfterPrice>0&&<div className="margin_b-30" ><p className="ex_delivery">미리 준비해주세요.</p></div>}
                                    <div className="margin_b-20 pay-line"></div>
                                    
                                    <div className="margin_b-20"><div className="checkblock">
                                        <CheckBtn onClick={handleAgreeClick} defaultValue={agree}/> </div> <span className="check_text">(필수) 주문하실 상품 및 결제, 주문 정보를 확인하였으며, 이에 동의합니다.</span></div>
                                        <LoadingOverlay
                                    active={loading}
                                    spinner
                                    text=''
                                    >
                                    <button className="btn_pay" onClick={handleSubmit}>결제하기</button>
                                    </LoadingOverlay>
                                </EsOrderRightPayBlock>
                                
                            </EsOrderRightContentsBlock>
                        </EsOrderSectionRightBlock>
                        
                    </EsOrderSectionContentsBlock>
                    <div className="payment-end"></div>
                </EsOrderContentsBlock>
            }
            
            <Toast/>
            <Footer />
            {isMobileOnly&&<div className="margin_b-50">&nbsp;</div>}
        </EsOrderBlock >
    );
};

export default EsOrderMulti;